'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

function SemigroupAnyExtensions(S) {
  var concatNamed = function (prefix, suffix) {
    return Curry._2(S.append, prefix, suffix);
  };
  return {
          concatNamed: concatNamed
        };
}

function SemigroupAnyInfix(S) {
  return {
          $pipe$plus$pipe: S.append
        };
}

exports.SemigroupAnyExtensions = SemigroupAnyExtensions;
exports.SemigroupAnyInfix = SemigroupAnyInfix;
/* No side effect */
